import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMemberStatusSchedulingFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.9085 12.463C12.791 12.6588 12.5835 12.7672 12.371 12.7672C12.2627 12.7672 12.1518 12.7388 12.0518 12.678L9.406 11.0947C9.21683 10.9822 9.10183 10.778 9.10183 10.558V7.15051C9.10183 6.80467 9.38183 6.52551 9.72683 6.52551C10.0718 6.52551 10.3518 6.80467 10.3518 7.15051V10.2038L12.6927 11.6055C12.9893 11.783 13.086 12.1672 12.9085 12.463ZM10.0002 2.08301C5.63433 2.08301 2.0835 5.63467 2.0835 9.99967C2.0835 14.3655 5.63433 17.9163 10.0002 17.9163C14.3652 17.9163 17.9168 14.3655 17.9168 9.99967C17.9168 5.63467 14.3652 2.08301 10.0002 2.08301Z"
	})
});
export default SvgMemberStatusSchedulingFill;
